import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./topbar.css";
import { Authme, showToast } from "../../Pages/Utils/utils";
import Loaderspinner from "../Loader";

const Topbar = ({ handleSidebar }) => {

  const [userDetails, setUserDetails] = useState(null);
  const [Loading, setLoading] = useState(false);

  const handleAuthme = async () => {
    let token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found!");
      return;
    }

    try {
      const response = await Authme(token);
      setUserDetails(response.data);
      localStorage.setItem("role", response?.data?.role)
    } catch (error) {
      console.error("Error during Authme request:", error);
    }
  };


  useEffect(() => {
    handleAuthme();
  }, []);

  const handleLogout = (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      showToast("Logout successfully", "success");
      setTimeout(() => {
        window.location.href = "/";
      }, [1000])
      if (token) {
        localStorage.removeItem("token");
      }
    } catch (error) {
      console.log(error)
      showToast("No active token found", "error");
    } finally {
      setLoading(false)
    }
  }

  // console.log(userDetails?.first_name, "userDetails.....")

  return (
    <>
      {Loading && <Loaderspinner />}

      <nav className="navbar navbar-main navbar-expand-lg border-bottom topbar d-block d-sm-none p-3">
        <li className="nav-item ps-3 d-flex align-items-center"
          onClick={handleSidebar}
          style={{ cursor: "pointer" }}
        >
          <span className="nav-link text-body p-0">
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
            </div>
          </span>
        </li>
        {/* <li className="navbar-brand m-0 d-flex justify-content-center align-items-center">
          <img
            src="/img/moneymatchlogo.png"
            className="resp-logo"
            alt="Logo"
          />
        </li> */}

        {/* <div className="navbar-brand m-0 d-flex justify-content-center align-items-center">
          
        </div> */}
      </nav>




      <nav className="navbar navbar-main navbar-expand-lg border-bottom topbar d-none d-sm-block">
        <div className="container-fluid py-1 px-3">
          <div
            className="d-none d-lg-inline text-white"
            style={{ fontSize: "17px", textTransform: "capitalize" }}
          >
            Hi, {userDetails ? userDetails?.first_name : "Admin"}
          </div>
          <div className="collapse navbar-collapse mt-sm-0 mt-2 ml-auto" style={{ flexGrow: "unset" }}>
            <ul className="navbar-nav justify-content-end" onClick={handleLogout}>
              <li className="nav-item d-flex align-items-center">
                <Link to="/" className="nav-link text-body text-white" style={{ textDecoration: "none" }}>
                  <img
                    src="/img/StripeCapitalIcon.png"
                    className="navbar-brand-img h-100 w-13"
                    alt="Logo"
                    width="30px"
                    style={{ marginBottom: "2px" }}
                  />
                  <span style={{ fontSize: "15px" }} className="d-inline text-white ml-1">
                    Log out
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Topbar;
